var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M26.5 5H6.5C5.94772 5 5.5 5.44772 5.5 6V26C5.5 26.5523 5.94772 27 6.5 27H26.5C27.0523 27 27.5 26.5523 27.5 26V6C27.5 5.44772 27.0523 5 26.5 5Z","stroke":"#11AF00","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M22.5 14L15.1667 22L11.5 18.0002","stroke":"#11AF00","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M22.5 3V7","stroke":"#11AF00","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M10.5 3V7","stroke":"#11AF00","strokeLinecap":"round","strokeLinejoin":"round","key":3}),React.createElement("path",{"d":"M5.5 11H27.5","stroke":"#11AF00","strokeLinecap":"round","strokeLinejoin":"round","key":4})]);
}

Calendar.defaultProps = {"width":"33","height":"32","viewBox":"0 0 33 32","fill":"none"};

module.exports = Calendar;

Calendar.default = Calendar;
